import { combineReducers } from "redux";
import User from "./User";
import CreateCourse from "./CreateCourse";

import CreateApps from "./CreateApps";
import CRMreducer from "./CRMreducer";


export default combineReducers({
  user: User,
  course:CreateCourse,
  app:CreateApps,
 crmData:CRMreducer
});  
    